import {gql} from '@apollo/client';

import {ButtonVariants} from '#component/base/Button';
import {IconName} from '#component/base/Icon';

export const CheckInFragment = gql`
  fragment CheckInFragment on CheckIn {
    id
    completed
    endedOn
    startedOn
  }
`;

export interface CheckInInfos {
  title: string;
  description: string | JSX.Element;
  icon: IconName;
  cta?: {
    label: string;
    action: () => void;
    variant: ButtonVariants;
  };
}

export type CheckInStatus = 'full' | 'available' | 'unavailable';
